module.exports = __webpack_public_path__ + "static/media/sport-chariots.d2e39b15.vtt";